type ClassValue = string | number | false | null | undefined | ClassValue[];

/** Tiny className joiner (no tailwind-merge: we avoid conflicting utilities by construction). */
export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  const walk = (v: ClassValue) => {
    if (!v) return;
    if (Array.isArray(v)) v.forEach(walk);
    else out.push(String(v));
  };
  values.forEach(walk);
  return out.join(' ');
}
